import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { OnboardingMfaEnroll } from "@/components/onboarding/onboarding-mfa-enroll";

export const Route = createFileRoute("/_authed/onboarding/mfa")({
  component: OnboardingMfaPage,
});

export function OnboardingMfaPage() {
  const navigate = useNavigate();
  return <OnboardingMfaEnroll onDone={() => navigate({ to: "/dashboard" })} />;
}
